var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnsiteTraining(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.5002 0.5H2.50016C1.5835 0.5 0.833496 1.25 0.833496 2.16667V8.83333H2.50016V2.16667H17.5002V15.5C18.4168 15.5 19.1668 14.75 19.1668 13.8333V2.16667C19.1668 1.25 18.4168 0.5 17.5002 0.5Z",
    fill: "#999999"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.8337 6.33333C10.8337 4.49167 9.34199 3 7.50033 3C5.65866 3 4.16699 4.49167 4.16699 6.33333C4.16699 8.175 5.65866 9.66667 7.50033 9.66667C9.34199 9.66667 10.8337 8.175 10.8337 6.33333ZM5.83366 6.33333C5.83366 5.41667 6.58366 4.66667 7.50033 4.66667C8.41699 4.66667 9.16699 5.41667 9.16699 6.33333C9.16699 7.25 8.41699 8 7.50033 8C6.58366 8 5.83366 7.25 5.83366 6.33333Z",
    fill: "#999999"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.8252 11.8C11.4252 11.0833 9.6085 10.5 7.50016 10.5C5.39183 10.5 3.57516 11.0833 2.17516 11.8C1.34183 12.225 0.833496 13.0833 0.833496 14.0167V16.3333H14.1668V14.0167C14.1668 13.0833 13.6585 12.225 12.8252 11.8ZM12.5002 14.6667H2.50016C2.50016 14.0667 2.41683 13.55 2.9335 13.2833C3.92516 12.775 5.52516 12.1667 7.50016 12.1667C9.47516 12.1667 11.0752 12.775 12.0668 13.2833C12.5918 13.55 12.5002 14.075 12.5002 14.6667Z",
    fill: "#999999"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnsiteTraining);
export default __webpack_public_path__ + "static/media/onsite-training.bffcb57781fd7203a7844333b1fdc901.svg";
export { ForwardRef as ReactComponent };